export enum IncidentAnswerQuestions {
    ActivityBefore = 'What was the employee doing just before the incident occurred?',
    Location = 'Where did the event occur?',
    TypeDescription = 'What was the injury or illness?',
    WhatHappened = 'What happened?',
    WhatHarmed = 'What object or substance directly harmed the employee?',
  }